import React from 'react'
import moment from 'moment';
import { EditListing } from './MyListings.js';

import Spinner from './Spinner.js';
import Profile from './Profile.js';
import Ads from './Ads.js';
import Share from './Utils/send.js'
import Save from './Utils/save.js'

import './Listings.css';

function Listings({ state, setState }) {

    const handleExpandListing = (listing) => {
        setState(state => ({
            ...state,
            listings: state.listings.map(l =>
                l === listing ? { ...l, open: true } : l
            )
        }));
    }

    const handleLister = (userid) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Profile state={state} setState={setState} userid={userid} />, modaltype: 'small', modaltitle: 'Profile' }))
    }

    const handleSeeMore = (offset) => {
        setState(state => ({ ...state, selectedoffset: offset }))
    }

    const handleOptions = (listing) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Options state={state} setState={setState} listing={listing} />, modaltype: 'small', modaltitle: 'Options' }))
    }

    const handleShare = async (listing) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Share state={state} setState={setState} listing={listing} />, modaltype: 'small', modaltitle: 'Share' }))
    };

    const handleSave = async (listing) => {
        let filename = listing.id
        setState(state => ({ ...state, modalopen: true, modalcontent: <Save state={state} setState={setState} listing={listing} filename={filename} />, modaltype: 'small', modaltitle: 'Save' }))
    };

    const handleEdit = (listingid) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditListing state={state} setState={setState} listingid={listingid} />, modaltype: 'large', modaltitle: 'Edit Listing' }))
    }

    function Options({ listing }) {
        let type = state.user.usertype;

        return (
            <div className='modal_actions'>
                {
                    type == 1 &&
                    <div className='modal_buttoncontainer'>
                        <button className='modal_button' onClick={() => handleEdit(listing)}>Edit Listing</button>
                    </div>
                }
                <div className='modal_buttoncontainer'>
                    <button className='modal_button' onClick={() => handleShare(listing)}>Share</button>
                </div>
                <div className='modal_buttoncontainer'>
                    <button className='modal_button' onClick={() => handleSave(listing)}>Save</button>
                </div>
            </div>
        );
    }

    function RenderImages({ images, link }) {
        if (!images || !Array.isArray(images)) return null;

        const displayedImages = images;
        const count = displayedImages.length;

        switch (count) {
            case 1:
                return (
                    <div className="listings_listingimages">
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <img className="listings_listingimages1_image" src={displayedImages[0]} loading="lazy" alt="" />
                        </a>
                    </div>
                );
            case 2:
                return (
                    <div className="listings_listingimages">
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <img className="listings_listingimages2_image" src={displayedImages[0]} loading="lazy" alt="" />
                        </a>
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <img className="listings_listingimages2_image" src={displayedImages[1]} loading="lazy" alt="" />
                        </a>
                    </div>
                );
            case 3:
                return (
                    <div className="listings_listingimages">
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <img className="listings_listingimages2_image" src={displayedImages[0]} loading="lazy" alt="" />
                        </a>
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <img className="listings_listingimages2_image" src={displayedImages[1]} loading="lazy" alt="" />
                        </a>
                    </div>
                );
            case 4:
                return (
                    <div className="listings_listingimages">
                        <div>
                            <a href={link} target="_blank" rel="noopener noreferrer">
                                <img className="listings_listingimages4_image" src={displayedImages[0]} loading="lazy" alt="" />
                            </a>
                            <a href={link} target="_blank" rel="noopener noreferrer">
                                <img className="listings_listingimages4_image" src={displayedImages[1]} loading="lazy" alt="" />
                            </a>
                        </div>
                        <div>
                            <a href={link} target="_blank" rel="noopener noreferrer">
                                <img className="listings_listingimages4_image" src={displayedImages[2]} loading="lazy" alt="" />
                            </a>
                            <a href={link} target="_blank" rel="noopener noreferrer">
                                <img className="listings_listingimages4_image" src={displayedImages[3]} loading="lazy" alt="" />
                            </a>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }

    return (
        <div className='listings'>
            <div className='listings_contentleft'>
                <Ads type='listings' />
            </div>

            {state.listingsloading == true && state.listings.length == 0 && < Spinner loading={true} size={30} position='fixed' />}

            <div className='listings_contentcenter'>
                {
                    state.listings.map((listing, index) => {
                        return (
                            <div
                                key={'listing' + index}
                                className={listing.new ? 'listings_listing listings_listingsnew' : 'listings_listing'}
                                offset={listing.offset}
                                remaining={listing.remaining}
                            >
                                <div className='listings_listinginfo'>
                                    <div className='listings_listinginfoleft'></div>
                                    <div className='listings_listinginfocenter'>
                                        <div className='listings_listinginfocentercontents'>
                                            <div
                                                className='listings_lister'
                                                onClick={() => handleLister(listing.listerid)}
                                            >
                                                {listing.listername}
                                            </div>
                                            <div className='listings_seperator'> · </div>
                                            <div className='listings_timestamp'>{moment(listing.timestamp * 1000).fromNow()}</div>
                                            <div className='listings_seperator'> · </div>
                                            <p className='listings_district'>{listing.district}</p>
                                            <div className='listings_seperator'> · </div>
                                            <p className='listings_community'>{listing.community}</p>
                                            <div className='listings_seperator'> · </div>
                                            <p className='listings_agreement'>{listing.agreement}</p>
                                            <div className='listings_seperator'> · </div>
                                            <p className='listings_type'>{listing.type}</p>
                                            <div className='listings_seperator'> · </div>
                                            <p className='listings_views'> ({listing.counter} Views)</p>
                                        </div>
                                    </div>
                                    <div className='listings_listinginforight'>
                                        <div className='listings_listinginforightoptionsbutton' onClick={() => handleOptions(listing)}>···</div>
                                    </div>
                                </div>
                                {
                                    (!listing.open && listing.descriptionfiltered.length > 8) &&
                                    <>
                                        <a
                                            className='listings_listingdescription'
                                            href={`${window.location.pathname}/${listing.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {
                                                listing.descriptionfiltered.slice(0, 8).map((line, key) => (
                                                    <div
                                                        key={'line' + key}
                                                        className={line.rtl === 1 ? 'listings_textdirectionalityright listings_textalignright' : 'listings_textdirectionalityleft listings_textalignleft'}
                                                    >
                                                        {line.data}
                                                    </div>
                                                ))
                                            }
                                        </a>
                                        <div
                                            className="listings_listingseemore"
                                            onClick={() => handleExpandListing(listing)}
                                        >
                                            See more
                                        </div>
                                    </>
                                }
                                {
                                    (listing.open || listing.descriptionfiltered.length <= 8) &&
                                    <a
                                        className='listings_listingdescription'
                                        href={`${window.location.pathname}/${listing.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {
                                            listing.descriptionfiltered.map((line, key) => (
                                                <div
                                                    key={'line' + key}
                                                    className={line.rtl === 1 ? 'listings_textdirectionalityright listings_textalignright' : 'listings_textdirectionalityleft listings_textalignleft'}
                                                >
                                                    {line.data}
                                                </div>
                                            ))
                                        }
                                    </a>
                                }

                                <RenderImages images={listing.images} link={window.location.pathname + '/' + listing.id} />
                            </div>
                        )
                    })
                }
                {
                    state.listings.length > 0 && state.listings[state.listings.length - 1].remaining > 0 &&
                    <div className='listings_seemorecontainer'>
                        <div
                            className='listings_seemore'
                            onClick={() => handleSeeMore(state.listings[state.listings.length - 1].offset)}
                            disabled={state.listingsloading}
                        >
                            {state.listingsloading ? 'Loading' : 'See more'}
                        </div>
                    </div>
                }
                {
                    state.listingsloading == false && state.listings.length == 0 &&
                    <div className='listings_nolistings'>
                        <div className='listings_nolistingstitle'>No Listings</div>
                        <div className='listings_nolistingsmessage'>TRY CHANGING FILTERS</div>
                    </div>
                }
            </div>

            <div className='listings_contentright'>
            </div>
        </div >
    )
}

export default Listings;